import { useDispatch, useSelector } from 'react-redux';
import { deviceTypes } from '../../../enums/deviceTypes';
import { login } from '../../../store/auth-actions';
import ChatAi from '../../shared/chatAi/ChatAi';
import Text from '../../shared/text/Text';
import Map from '../../shared/map/Map';
import Logo from '../../shared/logo/Logo';
import AccessibilityStatement from '../../shared/accessibilityStatement/AccessibilityStatement';
import classes from './LogoutPage.module.css';

const LogoutPage = () => {

    const { deviceType } = useSelector(state => state.responsive);
    const { texts } = useSelector(state => state.translate);
    const dispatch = useDispatch();

    return (
        deviceType === deviceTypes.mobile ?
            <div className={classes.LogoutMobile}>
                <div className={classes.TitleWrapper}>
                    <Text elementType='h1' className={classes.Title}>{texts.titleText}</Text>
                    <AccessibilityStatement />
                </div>
                <Logo />
                <div className={classes.MapWrapper}>
                    <Map showArrow={false} />
                </div>
                <button className={classes.Enter} onClick={() => dispatch(login())}>{texts.enter}</button>
            </div>
            :
            <div className={classes.LogoutWeb}>
                <ChatAi />
                <div className={classes.Block} onClick={() => dispatch(login())}>
                    <button className={classes.Enter}>{texts.enter}</button>
                </div>
            </div>
    )
}
export default LogoutPage;